<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.intro">
        <h2 :class="$style.enrollmentTitle">
          MDM Enrollment Info
        </h2>
        <div :class="$style.enrollmentInfo">
          <ul :class="$style.infoList">
            <li :class="$style.infoListItem">
              <span>MDM Enrolled</span>
              <span>{{ isDeviceWindowsMdmEnrolledText }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, MdmVendorStates, StoreModelMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapState } from 'vuex';
import MdmSettingsMixin from 'client/MDM/mixins/MdmSettingsMixin';

const systemModel = StoreModelMap[ItemTypeConsts.device];

export default {
  name: 'DeviceWindowsMdm',

  mixins: [
    MdmSettingsMixin,
  ],

  computed: {
    ...mapState(systemModel, [
      'item',
    ]),

    isDeviceWindowsMdmEnrolledText() {
      // note we can't use SystemMixin's isSystemMdmEnrolled as is here, because we want to
      // show 'yes' for external vendors unlike showing the ui pill
      const vendor = get(this.item, 'mdm.vendor');
      const vendorSet = vendor === MdmVendorStates.internal || vendor === MdmVendorStates.external;
      if (!vendorSet) {
        return 'no';
      }

      const windowsDeviceId = get(this.item, 'mdm.internal.windowsDeviceId');
      return this.formatMdmBooleanToText(windowsDeviceId);
    },
  },

  methods: {
    formatMdmBooleanToText(input) {
      if (input === null) return 'not available';

      return input ? 'yes' : 'no';
    },
  },
};
</script>

<style module>
@value (jcGrey100, jcGrey600, jcGrey700, jcSecondary) from '~css/brand-colors.css';
@value (max-width-x-large) from '~css/breakpoints.css';

.container {
  height: 100%;
  overflow: auto;
  padding: 10px 20px 10px;
  width: 100%;
}

.content {
  background-color: white;
  border: 0.5px solid var(--jc-border-color);
  border-radius: 2px;
  box-shadow: 0 0 8px 0.5px rgba(0, 0, 0, 0.045);
  margin-bottom: 0.5rem;
  margin-top: 10px;
  text-decoration: none;
}

.content .enrollmentTitle {
  color: jcGrey600;
  font-size: 16px;
  font-weight: 600;
}

.container .content p {
  margin: 0 0 15px;
}

.enrollmentInfo .infoList {
  margin: 0;
  padding: 0;
  width: 50%;
}

.infoListItem {
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  margin: 15px 0;
}

.infoListItem > span:first-child {
  font-weight: bold;
  margin-right: 15px;
}

.infoListItem > span:last-child {
  text-align: right;
}

.intro {
  background-color: white;
  padding: 20px 40px;
}
</style>
